import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { APP_API_URL } from './apiConstants';

const headers = {
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*',
};

export const requestDataDeletion = createAsyncThunk('api/requestDataDeletion', async (data) =>
  axios
    .post(`${APP_API_URL}/request-data-deletion`, { ...data, source: 'web' }, { headers })
    .then((response) => response.data)
    .catch((e) => e)
);

export const verifyDataDeletionEmail = createAsyncThunk(
  'api/verifyDataDeletionEmail',
  async (data) =>
    axios
      .post(`${APP_API_URL}/verify-data-deletion-email`, { ...data, source: 'web' }, { headers })
      .then((response) => response.data)
      .catch((e) => e)
);

export const verifyDataDeletionPhone = createAsyncThunk(
  'api/verifyDataDeletionPhone',
  async (data) =>
    axios
      .post(`${APP_API_URL}/verify-data-deletion-phone`, { ...data, source: 'web' }, { headers })
      .then((response) => response.data)
      .catch((e) => e)
);

const deleteAccountSlice = createSlice({
  name: 'deleteAccount',
  initialState: {
    loading: false,
    deleteAccountData: {},
    error: '',
  },
  extraReducers: {
    [requestDataDeletion.pending]: (state) => {
      state.loading = true;
    },
    [requestDataDeletion.fulfilled]: (state, action) => {
      state.loading = false;
      state.deleteAccountData = action.payload;
    },
    [requestDataDeletion.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    [verifyDataDeletionEmail.pending]: (state) => {
      state.loading = true;
    },
    [verifyDataDeletionEmail.fulfilled]: (state, action) => {
      state.loading = false;
      state.deleteAccountData = action.payload;
    },
    [verifyDataDeletionEmail.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    [verifyDataDeletionPhone.pending]: (state) => {
      state.loading = true;
    },
    [verifyDataDeletionPhone.fulfilled]: (state, action) => {
      state.loading = false;
      state.deleteAccountData = action.payload;
    },
    [verifyDataDeletionPhone.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export default deleteAccountSlice.reducer;
